import {
    REQ_DATA,

    GET_CATEGORIES_SUCCESS,
    GET_CATEGORIES_FAILURE,

    GET_AUTOCOMPLETE_SUCCESS,
    GET_AUTOCOMPLETE_FAILURE,

    SET_AREAS_BY_RADIUS,
    SET_AREAS_BY_REGION,

    UPDATE_CATEGORY,
} from './actions';

const initialState = {
    categories: [],
    subjects: [],
    autocomplete: [],
};


export default (state = initialState, { type, payload }) => {

    switch (type) {
        case REQ_DATA:
            return {
                ...state,
                categories: {
                    ...state.categories,
                    ...state.autocomplete,
                    loading: true
                }
            };
        case GET_CATEGORIES_SUCCESS:
            return {
                ...state,
                categories: {
                    ...state.categories,
                    data: payload,
                    loading: true,
                }
            }
        case GET_CATEGORIES_FAILURE:
            return {
                ...state,
                categories: {
                    ...state.categories,
                    data: null,
                    loading: false,
                    loadError: payload
                }
            };
        case GET_AUTOCOMPLETE_SUCCESS:
            return {
                ...state,
                autocomplete: {
                    ...state.autocomplete,
                    data: payload,
                    loading: true,
                }
            }
        case GET_AUTOCOMPLETE_FAILURE:
            return {
                ...state,
                autocomplete: {
                    ...state.autocomplete,
                    data: null,
                    loading: false,
                    loadError: payload
                }
            };
        case SET_AREAS_BY_RADIUS:
            return {
                ...state,
                categories: {
                    data: [
                        ...state.categories.data.map(category => {
                            return {
                                ...category,
                                subjects: category.subjects && category.subjects.map(subject => {
                                    if (subject.id === payload.subjectId) {
                                        return {
                                            ...subject,
                                            areasByRadius: payload.areas,
                                        }
                                    } else {
                                        return { ...subject }
                                    }
                                })
                            }
                        }),
                    ]
                }
            };
        case SET_AREAS_BY_REGION:
            return {
                ...state,
                categories: {
                    data: [
                        ...state.categories.data.map(category => {
                            return {
                                ...category,
                                subjects: category.subjects && category.subjects.map(subject => {
                                    if (subject.id === payload.subjectId) {
                                        return {
                                            ...subject,
                                            areasByRegion: payload.selectedDistricts,
                                        }
                                    } else {
                                        return { ...subject }
                                    }
                                })
                            }
                        }),
                    ]
                }
            };
        case UPDATE_CATEGORY:
            return {
                ...state,
                categories: {
                    data: [
                        ...state.categories.data.map(category => {
                            if (category.ID === payload.ID) {
                                return {
                                    ...payload,
                                }
                            } else {
                                return {
                                    ...category,
                                }
                            }
                        }),
                    ]
                }
            };
        default:
            return state;
    }
}